import {
    InputSwitch as PrimeInputSwitch,
    InputSwitchProps as PrimeInputSwitchProps,
} from 'primereact/inputswitch';
import { forwardRef, ReactNode, Ref } from 'react';

export type SwitchProps = PrimeInputSwitchProps & {
    'data-testid'?: string;
};

function SwitchComponent(
    props: SwitchProps,
    ref: Ref<PrimeInputSwitch>,
): ReactNode {
    const { 'data-testid': dataTestId, ...rest } = props;
    const testId = dataTestId || rest.name;

    return (
        <PrimeInputSwitch
            ref={ref}
            pt={{ input: { 'data-testid': testId } }}
            {...rest}
        />
    );
}

export const Switch = forwardRef(SwitchComponent);
